import { render, staticRenderFns } from "./CurriculumReadEEC.vue?vue&type=template&id=7d521068&scoped=true&"
import script from "./CurriculumReadEEC.vue?vue&type=script&lang=ts&"
export * from "./CurriculumReadEEC.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d521068",
  null
  
)

export default component.exports